import React, {  useEffect } from "react";
import "../assets/css/Homestyle.css";

// All components  import 
import CategoryCard from "../components/CategoryCard";
import Latest from "../components/Latest";
import SearchHeader from "../components/SearchHeader";
import BrandAll from "../components/BrandAll";
import Spinner from "../components/Spinner";

// {/* Redux state  import */}
import { useDispatch, useSelector } from "react-redux";
import { featchCarData, getlatestCar } from "../Redux/Slice/DataSlice";


const Home = () => {

 //Redux all state import 
  const { latestCar, Brands, Categories, status } = useSelector((state) => state.CarData);
  
 // dispatch function  import 
  const dispatch = useDispatch();

  useEffect(() => {
    //feaatching the data when its load  

    dispatch(featchCarData()).then(() => {
      //after dispatching the main  data then featch the leatest car  
      dispatch(getlatestCar());
    });
  }, []);
  return (
    <>
      <div className="w-[100%]">
        {status === "pending" ? (
          <Spinner />
        ) : (
          <div className="w-[100%]">
           {/* search bar component */}
            <SearchHeader />

            <h2 className="text-2xl font-extrabold text-gray-900 text-center p-5 w-full mt-5 ">
              Categories of Cars
            </h2>

             {/* Categories component  calling  categories Data form Redux  */}

            <div className="w-[100%] flex justify-center items-center">
              <div className="w-[100%] flex justify-center items-center flex-wrap sm:flex-row flex-col">
                
                {Categories &&
                  Categories.map((x, index) => {
                    if (index < 6) {
                      return <CategoryCard x={x} key={x.id} />;
                    }
                  })}
              </div>
            </div>

            <h2 className="text-2xl font-extrabold text-gray-900 text-center p-5 w-full">
              Latest Cars
            </h2>
             {/* Leatest car component calling  latestCar Data form Redux  */}
            <div className=" flex justify-center items-start flex-col sm:flex-row  mt-3 ml-3  ">
              {latestCar &&
                latestCar.map((x, index) => {
                  return <Latest car={x} key={index} />;
                })}
            </div>

            <h2 className="text-2xl font-extrabold text-gray-900 text-center pt-5 w-full">
              Popular Brands
            </h2>
             {/* Brands component calling  Brands Data form Redux  */}

            <div className=" w-[100%] flex justify-center items-center gap-2 flex-col sm:flex-row  mt-10 mb-10">
              {Brands &&
                Brands.map((x, index) => {
                  return <BrandAll Brand={x} key={index} />;
                })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
